<template>
  <transition name="fade">
    <div class="scanner" v-if="q !== ''">{{ q }}</div>
  </transition>
</template>

<script>
import { scanMixin } from '@/mixins/scanMixin'

export default {
  props: {
    expectations: {
      type: Array,
      default: () => ['productId', 'shelfSpace', 'ean']
    },
    redirect: {
      type: Object,
      default: () => ({})
    },
    uppercase: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      q: ''
    }
  },
  mixins: [scanMixin],
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    handleKeyDown(e) {
      if (!e.ctrlKey && !e.metaKey && e.target.tagName !== 'INPUT') {
        switch (e.key) {
          case 'Enter':
            this.submitScan()
            break
          case 'Backspace':
            if (e.altKey) {
              this.q = ''
            } else {
              this.q = this.q.slice(0, -1)
            }
            break
          default:
            if (e.key.length === 1) {
              const newChar = this.uppercase ? e.key.toUpperCase() : e.key
              this.q = this.q + newChar
            }
            break
        }
      }
    },
    submitScan() {
      if (this.q !== '') {
        let validTypeFound = false
        this.expectations.forEach(type => {
          if (!validTypeFound && this.validateScanType({ type, q: this.q }) === true) {
            validTypeFound = type
          }
        })
        if (validTypeFound) {
          const { data, redirect, error } = this.getScanResult({ type: validTypeFound, q: this.q })
          const triggerRedirect =
            typeof this.redirect[validTypeFound] !== 'undefined'
              ? this.redirect[validTypeFound]
              : typeof this.redirect.all !== 'undefined'
              ? this.redirect.all
              : true
          if (error) {
            this.$notify({
              group: 'main',
              type: 'scan-warning',
              ...error
            })
          } else if (triggerRedirect) {
            this.$router.push(redirect).catch(() => {})
          } else {
            this.$emit('scan', {
              validTypeFound,
              q: this.q,
              data,
              redirect
            })
          }
        } else {
          this.$notify({
            group: 'main',
            type: 'scan-warning',
            title: 'Wrong Barcode Type',
            text: `Don't know what to do with the barcode "${this.q}" here`
          })
        }
        this.q = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scanner {
  background: yellowgreen;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.5rem;
  font-size: 0.75rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-leave-to {
  opacity: 0;
}
</style>
